import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { EXPERIENCES } from "../data/experiences";

const ExperienceEntry = ({ experience }) => (
  <section id={experience.id} className="experience-entry" data-testid={`experience-${experience.id}`}>
    <figure>
      <img src={experience.detailImage?.src || experience.image} alt={experience.detailImage?.alt || experience.imageAlt} width={experience.detailImage?.width || experience.width} height={experience.detailImage?.height || experience.height} className="artwork-image experience-artwork" loading="lazy" data-testid={`experience-image-${experience.id}`} />
      <figcaption className="artwork-caption">{experience.detailImage?.caption || experience.caption}</figcaption>
    </figure>
    <div>
      <h2 className="editorial-heading" data-testid={`experience-name-${experience.id}`}>{experience.name}</h2>
      <p className="font-serif text-2xl text-maroon mt-5" data-testid={`experience-title-${experience.id}`}>{experience.title}</p>
      <p className="editorial-body mt-5" data-testid={`experience-description-${experience.id}`}>{experience.description}</p>
      <div className="mt-8 py-6 border-y border-maroon/20 editorial-body" data-testid={`experience-arrangements-${experience.id}`}>
        <p className="font-medium text-maroon mb-3">Arrangements on enquiry</p>
        <p>Ask us about dates, duration, the meeting area and walking requirements. Let us know your group size, interests and any access needs so we can discuss a suitable experience.</p>
      </div>
      <Link to={`/contact?experience=${encodeURIComponent(experience.name)}`} className="editorial-button mt-8" data-testid={`experience-enquire-${experience.id}`}>Enquire about this experience <ArrowRight size={16} /></Link>
    </div>
  </section>
);

export default function Tours() {
  return (
    <main data-testid="experiences-page" className="bg-ivory">
      <header className="editorial-container page-intro">
        <p className="editorial-label mb-6">DELHI, THROUGH ITS STORIES</p>
        <h1 className="font-accent text-4xl sm:text-5xl lg:text-6xl text-maroon" data-testid="experiences-headline">Experiences</h1>
        <p className="editorial-body mt-6 max-w-2xl">Explore the histories, people and living traditions of Delhi. Tell us what draws you to the city, and we can discuss an experience shaped around your curiosity.</p>
        <nav className="mt-9 flex flex-wrap gap-x-8 gap-y-4" aria-label="Find an experience" data-testid="experience-jump-links">
          {EXPERIENCES.map((experience) => <Link key={experience.id} to={`#${experience.id}`} className="editorial-link" data-testid={`jump-${experience.id}`}>{experience.name} <ArrowRight size={14} /></Link>)}
        </nav>
      </header>
      <div className="editorial-container pb-24" data-testid="experiences-collection">
        {EXPERIENCES.map((experience) => <ExperienceEntry key={experience.id} experience={experience} />)}
      </div>


    </main>
  );
}
